/* oxlint-disable react/exhaustive-deps, rc/set-state-in-effect, typescript/no-confusing-void-expression */
import { useEffect, useState } from 'react'

export function useMediaQuery(query: string): boolean {
  const getMatches = (query: string) =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches // Prevents SSR issues

  const [matches, setMatches] = useState(getMatches(query))

  const handleChange = () => setMatches(getMatches(query))

  useEffect(() => {
    const matchMedia = window.matchMedia(query)
    handleChange() // Triggered at the first client-side load and if query changes
    matchMedia.addEventListener('change', handleChange)
    return () => matchMedia.removeEventListener('change', handleChange)
  }, [query])

  return matches
}

// chrome devtools get stuck on "(pointer: fine)" media query when switching from mobile to desktop mode
export function useDevToolsTolerantMediaQueryPrivateImplementation(
  query: string,
): boolean {
  const getMatches = (query: string) =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches

  const [matches, setMatches] = useState(getMatches(query))

  const handleChange = () => {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query)
    // Immediately check once on mount
    handleChange()

    // Listen for normal media-query changes
    matchMedia.addEventListener('change', handleChange)

    // **Also** listen for resize events
    const handleResize = () => handleChange()
    window.addEventListener('resize', handleResize)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
      window.removeEventListener('resize', handleResize)
    }
  }, [query])

  return matches
}
